import { useLightbox } from "../context/LightboxContext";

// An <img> that opens the full picture in the lightbox when clicked.
// Pass zoom={false} to render a plain (non-clickable) image.
export const ZoomImg = ({ src, alt = "", className = "", zoom = true, ...rest }) => {
  const { open } = useLightbox();
  if (!zoom) {
    return <img src={src} alt={alt} className={className} {...rest} />;
  }
  return (
    <img
      src={src}
      alt={alt}
      role="button"
      tabIndex={0}
      aria-label={alt ? `View image: ${alt}` : "View full image"}
      onClick={() => open(src, alt)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          open(src, alt);
        }
      }}
      className={`${className} cursor-zoom-in`}
      {...rest}
    />
  );
};
